import { z } from 'zod';
import { editorSummarySchema, imageReferenceSchema, nonEmptyUpdate, seoPathSchema, utcInstantSchema, } from './common.js';
const pageSeoEditableShape = {
    path: seoPathSchema,
    title: z.string().min(1),
    description: z.string().min(1),
    keywords: z.array(z.string().min(1)),
    ogTitle: z.string().min(1).nullable(),
    ogDescription: z.string().min(1).nullable(),
    ogImageUrl: imageReferenceSchema.nullable(),
    robots: z.string().min(1),
};
export const publicPageSeoSchema = z.object(pageSeoEditableShape);
export const publicPageSeoFields = Object.freeze(Object.keys(publicPageSeoSchema.shape));
export const adminPageSeoSchema = publicPageSeoSchema.extend({
    id: z.number().int().positive(),
    updatedAt: utcInstantSchema,
    updatedBy: editorSummarySchema.nullable(),
});
export const adminPageSeoListSchema = z.array(adminPageSeoSchema);
export const createPageSeoSchema = z.object({
    path: pageSeoEditableShape.path,
    title: pageSeoEditableShape.title,
    description: pageSeoEditableShape.description,
    keywords: pageSeoEditableShape.keywords.optional(),
    ogTitle: pageSeoEditableShape.ogTitle.optional(),
    ogDescription: pageSeoEditableShape.ogDescription.optional(),
    ogImageUrl: pageSeoEditableShape.ogImageUrl.optional(),
    robots: pageSeoEditableShape.robots.optional(),
});
export const updatePageSeoSchema = nonEmptyUpdate(z.object(pageSeoEditableShape));
export const pageSeoQuerySchema = z.object({ path: seoPathSchema });
//# sourceMappingURL=page-seo.js.map